(() => {
    const SELECTOR_RADIO = ".radio-addon-input";

    function syncRadio(rb) {
        const targetId = rb.dataset.targetPropInput;
        const hiddenInput = document.getElementById(targetId);

        if (!hiddenInput) {
            console.warn("[Radio Debug] Hidden input not found for", targetId);
            return;
        }

        if (rb.checked) {
            hiddenInput.disabled = rb.dataset.propDisabled === "true";

            // Reset y marcar solo si está checked
            const radios = document.querySelectorAll(`input[name="${rb.name}"]`);
            radios.forEach((input) => {
                input.closest(".radio-addon-option")?.classList.remove("selected");
            });
            rb.closest(".radio-addon-option")?.classList.add("selected");
        }
    }


    function initRadio(rb) {
        syncRadio(rb); // inicializa el estado al cargar
        rb.addEventListener("change", () => syncRadio(rb));
    }

    // Inicializar radios al cargar
    document.querySelectorAll(SELECTOR_RADIO).forEach(initRadio);

    // Observar si se añaden radios dinámicamente
    const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
            m.addedNodes.forEach((node) => {
                if (!(node instanceof HTMLElement)) return;
                node.querySelectorAll?.(SELECTOR_RADIO).forEach(initRadio);
            });
        }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
})();
